import { createSelector } from 'reselect';
import { AppState } from '../../base/types';

const isSavingSelector = (state: AppState): boolean => state.app.statistics.isSaving || false;

export const getIsSavingSelector = createSelector(
    [isSavingSelector],
    (isSaving) => isSaving,
);
